import { isReference } from '@medplum/core'
import type { Patient, Reference } from '@medplum/fhirtypes'
import { referenceDisplay } from '@seen/core/display'
import { Participant } from '@seen/core/models/patients/participant'
import { cn } from '@seen/ui'
import type { JSX } from 'react'
import { Link } from '#src/components/core/Link.tsx'
import { PatientName } from '#src/components/patient/PatientName.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export interface HoverParticipantProps {
  participant: Participant | Reference<Patient> | undefined
  className?: string
  prefix?: string
}

export function HoverParticipant({
  participant: participantOrReference,
  className,
  prefix,
}: HoverParticipantProps): JSX.Element {
  const { data } = useRead(
    Participant,
    isReference(participantOrReference) ? participantOrReference : undefined,
    {
      query: {
        enabled: !(participantOrReference instanceof Participant),
      },
    }
  )
  const participant =
    participantOrReference instanceof Participant
      ? participantOrReference
      : data

  const participantReference =
    participantOrReference instanceof Participant
      ? participantOrReference.reference
      : participantOrReference

  return (
    <Link
      to={participant?.relativeUrl ?? '#'}
      className={cn(
        'font-medium text-foreground decoration-1 underline-offset-[2.5px] hover:underline group-[.ProseMirror-selectednode]:bg-[lch(53_52.26_286.91/0.4)]',
        className
      )}
      tabIndex={-1}
    >
      <span className="overflow-hidden text-nowrap text-ellipsis decoration-1 underline-offset-[2.5px] hover:underline">
        {prefix}
        {participant && <PatientName participant={participant} />}
        {!participant && referenceDisplay(participantReference)}
      </span>
    </Link>
  )
}
